import type { MutationTree } from 'vuex'
import type { ProjectState } from './types'
import {
  GET_LIST_PROJECTS,
  SELECTED_PROJECT_IDS,
  SET_CURRENT_PAGE,
  SET_SELECTED_ROWS,
} from './types'

export const mutations: MutationTree<ProjectState> = {
  [GET_LIST_PROJECTS](state: ProjectState, projects: Project[]) {
    state.projects = projects
  },
  [SELECTED_PROJECT_IDS](state: ProjectState, selected: string[]) {
    state.selectedProjectIds = selected
  },
  [SET_CURRENT_PAGE](state: ProjectState, numPage: number) {
    state.currentPage = numPage
  },
  [SET_SELECTED_ROWS](state: ProjectState, rows: number) {
    state.selectedRows = rows
  },
}
